export enum FlowType {
  MANUAL = 'MANUAL',
  REPRINT_BADGE = 'REPRINT_BADGE',
  DAILY_CHECKIN_CHECKOUT = 'DAILY_CHECKIN_CHECKOUT',
  COVID_DECLARATION = 'COVID_DECLARATION',
  PRE_CHECKIN = 'PRE_CHECKIN',
  EXISTING_QRCODE = 'EXISTING_QRCODE',
  UNDEFINED = 'UNDEFINED'
}
